import { gql } from '@apollo/client';

export const CreateBusiness = gql`
  mutation CreateBusiness($input: BusinessInputType!) {
    createBusiness(input: $input) {
      business {
        message
        isSomething
      }
      ok
      error
    }
  }
`;
